app.controller('exercisesIndexCtrl', [
    '$scope', '$rootScope', '$http', 'exerciseService', function ($scope, $rootScope, $http, exerciseService) {
    	var vm = this;

    	vm.exerciseService = exerciseService;
    	vm.exerciseService.load();

    	vm.delete = function(exercise, $event) {
    		vm.exerciseService.askDelete(exercise, $event);
    	}
    }
]);